import React, { useState, useEffect } from 'react';
import UserAPI from '../components/UserAPI';
import EmotionScanner from '../components/EmotionScanner';
import SongsMenu from '../components/SongsMenu';
import SettingsMenuCreate from '../components/SettingsMenuCreate';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import Leaderboard from '../components/Leaderboard';
import creatorConsoleImage from '../images/creatorConsole.png';
import CreatorTutorial from '../components/CreatorTutorial';
import { StyledCard } from '../utils/StyledComponents';

const Create = () => {
  const [sessionOnGoing, setSessionOnGoing] = useState(null);
  const [settingsMenu, setSettingsMenu] = useState(false);
  const [songsMenu, setSongsMenu] = useState(false);
  const [tutorial, setTutorial] = useState(false);

  useEffect(() => {
    let mounted = true;

    const getSessionStatus = async () => {
      const requestBody = JSON.stringify({
        'request_type': 'user',
        'idToken': localStorage.getItem('idToken'),
        'user_request_type': 'getsessionstatus'
      });
      const jsonData = await UserAPI(requestBody);
      if (mounted) {
        if (jsonData) {
          const result = JSON.parse(jsonData.body);
          setSessionOnGoing(result.session_ongoing ? true : false);
        }
      }
    };

    getSessionStatus();

    return () => {
      mounted = false;
      setSessionOnGoing(null);
      setSettingsMenu(false);
      setSongsMenu(false);
    };
  }, []);

  const startstopSession = async () => {
    const requestBody = JSON.stringify({
      'request_type': 'user',
      'idToken': localStorage.getItem('idToken'),
      'user_request_type': 'startstopsession'
    });
    const jsonData = await UserAPI(requestBody);
    const result = JSON.parse(jsonData.body);
    setSessionOnGoing(result.session_ongoing);
  };

  const copyOverlayUrl = () => {
    const idToken = localStorage.getItem('idToken');
    const payloadBase64 = idToken.split('.')[1];
    const decodedPayload = JSON.parse(atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/')));
    const eventId = decodedPayload['cognito:username'];
    const overlayUrl = `${window.location.origin}/overlay/${eventId}?session_name=${eventId}`;
    navigator.clipboard.writeText(overlayUrl);
    alert('Overlay URL copied to clipboard!');
  };

  return (
    <Container 
      fluid 
      className="mt-5"
    >
      <Row className="justify-content-center mb-4">
        <Col className="text-center">
          <Image
            src={creatorConsoleImage}
            alt="Creator Console"
            fluid
            style={{ maxWidth: '100%' }}
          />
        </Col>
      </Row>

      <Row>
        <Col md="auto" className="d-flex flex-column gap-2">
          {localStorage.getItem('idToken') && (
            <>
              <Button 
                variant="outline-light"
                onClick={startstopSession} 
                id="sessionButton"
              >
                {sessionOnGoing ? 'Stop Session' : 'Start Session'}
              </Button>
              <Button 
                variant="outline-light"
                onClick={copyOverlayUrl}
              >
                Copy overlay URL
              </Button>
              <Button 
                variant="outline-light"
                onClick={() => setSettingsMenu(!settingsMenu)}
              >
                {settingsMenu ? 'Close settings' : 'Open settings'}
              </Button>
              <Button 
                variant="outline-light"
                onClick={() => setSongsMenu(!songsMenu)}
              >
                {songsMenu ? 'Close song list' : 'Open song list'}
              </Button>
              
            </>
          )}
          <Button 
                variant="outline-light"
                onClick={() => setTutorial(!tutorial)}
              >
                {tutorial ? 'Close tutorial' : 'Open tutorial'}
              </Button>
        </Col>

        <Col>
          {tutorial && (
            <StyledCard>
              <CreatorTutorial />
            </StyledCard>
          )}
          
          {sessionOnGoing && (
            <>
              <StyledCard>
                <EmotionScanner />
              </StyledCard>
              <StyledCard>
                <Leaderboard />
              </StyledCard>
            </>
          )}
          
          {settingsMenu && (
            <StyledCard>
              <SettingsMenuCreate />
            </StyledCard>
          )}
          
          {songsMenu && (
            <StyledCard>
              <SongsMenu />
            </StyledCard>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Create;
